import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  inject
} from '@angular/core';
import { NowTabBar } from '@now/dpl';
import { DetailPageService } from '../../../../services/detail-page/detail-page.service';

export const TabTypes = ['Informationen', 'Daten und Fakten', 'Anbieter'] as const;
export type Tab = (typeof TabTypes)[number];

@Component({
  selector: 'now-wbsuche-lib-detail-tabbar',
  templateUrl: './detail-tabbar.component.html',
  styleUrls: ['detail-tabbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class DetailTabbarComponent implements AfterViewInit, OnChanges {
  private readonly detailPageService = inject(DetailPageService);

  @Input()
  public currentTab: Tab = 'Informationen';

  @Output()
  public currentTabChange = new EventEmitter<any>();

  @ViewChild('tabbarContainer')
  tabbarContainer!: ElementRef;

  private nowTabBar?: NowTabBar;

  TabTypes = TabTypes;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentTab.currentValue !== changes.currentTab.previousValue) {
      this.selectNowTab(changes.currentTab.currentValue);
    }
  }

  ngAfterViewInit(): void {
    this.nowTabBar = NowTabBar.init(this.tabbarContainer.nativeElement);
    this.selectNowTab(this.currentTab);
  }

  private readonly selectNowTab = (tab: Tab) => {
    const index = TabTypes.indexOf(tab);
    this.nowTabBar?.selectTab(index);
  };

  setSelectedTab(index: number) {
    const tab = TabTypes[index];
    this.currentTab = tab;
    this.currentTabChange.emit(tab);
    this.detailPageService.setCurrentTab(tab);
  }

  getTabText(index: number): string {
    return TabTypes[index];
  }

  isTabSelected(index: number): boolean {
    return index === TabTypes.indexOf(this.currentTab);
  }
}
